"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("../../../openapi");
const IContactInfo_1 = __importDefault(require("../../../shared/models/IContactInfo"));
const IInvoiceNumberSettings_1 = require("../invoice/IInvoiceNumberSettings");
const INotificationConfiguration_1 = require("../notifications/INotificationConfiguration");
const IBillingAddress_1 = __importDefault(require("./IBillingAddress"));
const IConvenienceFeesSettings_1 = __importDefault(require("./IConvenienceFeesSettings"));
const PayrixMerchantStatus_1 = require("./PayrixMerchantStatus");
class INotificationSettings {
    sendersName;
    notificationConfigurations;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], INotificationSettings.prototype, "sendersName", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => INotificationConfiguration_1.INotificationConfiguration) })
], INotificationSettings.prototype, "notificationConfigurations", void 0);
class IAppBillingOrganization {
    payrixMerchantId;
    payrixApiKey;
    payrixProducts;
    payrixLoginId;
    invoiceNumberSettings;
    class;
    payrixMerchantStatus;
    contact;
    address;
    logo;
    lastRequestedWmsEventId;
    lastFetchTimestamp;
    convenienceFeesSettings;
    notificationSettings;
    canCustomerDownloadInvoiceDetails;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IAppBillingOrganization.prototype, "payrixMerchantId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IAppBillingOrganization.prototype, "payrixApiKey", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'object',
        properties: {
            additionalProperties: { type: 'string' },
        },
    })
], IAppBillingOrganization.prototype, "payrixProducts", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IAppBillingOrganization.prototype, "payrixLoginId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IInvoiceNumberSettings_1.IInvoiceNumberSettings)
], IAppBillingOrganization.prototype, "invoiceNumberSettings", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string' } })
], IAppBillingOrganization.prototype, "class", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(PayrixMerchantStatus_1.PayrixMerchantStatus) })
], IAppBillingOrganization.prototype, "payrixMerchantStatus", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IContactInfo_1.default)
], IAppBillingOrganization.prototype, "contact", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IBillingAddress_1.default)
], IAppBillingOrganization.prototype, "address", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IAppBillingOrganization.prototype, "logo", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IAppBillingOrganization.prototype, "lastRequestedWmsEventId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IAppBillingOrganization.prototype, "lastFetchTimestamp", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IConvenienceFeesSettings_1.default)
], IAppBillingOrganization.prototype, "convenienceFeesSettings", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => INotificationSettings)
], IAppBillingOrganization.prototype, "notificationSettings", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean', default: true })
], IAppBillingOrganization.prototype, "canCustomerDownloadInvoiceDetails", void 0);
exports.default = IAppBillingOrganization;
